import styles from "./simulacao-tooltip.module.scss";
import type { SimulacaoTooltipViewModel } from "./types-simulacao-tooltip";

export function SimulacaoTooltipView({
  titulo,
  subtitulo,
  campos,
  linhas,
  rodape,
  selo,
}: SimulacaoTooltipViewModel) {
  return (
    <div className={styles.card} data-testid="simulacao-tooltip">
      <header className={styles.header}>
        <div className={styles.titulo}>
          <strong>{titulo}</strong>
          <span className={styles.selo}>{selo}</span>
        </div>
        {subtitulo ? <span className={styles.subtitulo}>{subtitulo}</span> : null}
      </header>
      {campos.length > 0 || linhas.length > 0 ? (
        <dl className={styles.dados}>
          {campos.map((campo) => (
            <div key={campo.rotulo} className={styles.linha}>
              <dt>{campo.rotulo}</dt>
              <dd>
                {campo.anterior ? (
                  <>
                    <s className={styles.anterior}>{campo.anterior}</s>
                    <span className={styles.seta} aria-hidden="true">
                      →
                    </span>
                  </>
                ) : null}
                {campo.valor}
              </dd>
            </div>
          ))}
          {linhas.map((linha) => (
            <div key={linha} className={styles.linha}>
              <dd className={styles.texto}>{linha}</dd>
            </div>
          ))}
        </dl>
      ) : null}
      <hr className={styles.divisor} />
      <p className={styles.rodape}>{rodape}</p>
    </div>
  );
}
